module.exports = __webpack_public_path__ + "static/media/writer.54ab122a.jpg";